import { defineComponent as d, computed as i, openBlock as a, createElementBlock as l, normalizeClass as m, createElementVNode as t, toDisplayString as r, normalizeStyle as p, createCommentVNode as f } from "vue";
import { _ as b } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './css/ProductVariantCard.css';const v = { class: "card-top" }, y = { class: "shortcode" }, g = { class: "card-bottom" }, C = {
  key: 0,
  class: "price"
}, S = /* @__PURE__ */ d({
  __name: "ProductVariantCard",
  props: {
    /**
     * The variant shortcode (e.g., "M18W")
     * Displayed prominently in the top section
     */
    shortcode: {
      type: String,
      required: !0
    },
    /**
     * The variant label/subline (e.g., "München")
     * Displayed in the bottom section
     */
    subline: {
      type: String,
      required: !0
    },
    /**
     * Whether this variant is currently selected
     * Controls active styling (primary fill, border)
     */
    isActive: {
      type: Boolean,
      default: !1
    },
    /**
     * Optional price display (e.g., "1.234,00 €")
     */
    price: {
      type: String,
      default: void 0
    }
  },
  emits: ["select"],
  setup(e) {
    const o = e, c = i(() => {
      const s = o.subline.length;
      return s > 24 ? "subline-long" : s > 20 ? "subline-medium" : "";
    }), u = i(() => o.subline.length > 24 ? { fontSize: "0.7rem" } : {});
    return (s, n) => (a(), l("button", {
      class: m(["product-variant-card", [
        { active: e.isActive },
        c.value
      ]]),
      type: "button",
      onClick: n[0] || (n[0] = (h) => s.$emit("select"))
    }, [
      t("div", v, [
        t("span", y, r(e.shortcode), 1)
      ]),
      n[1] || (n[1] = t("div", { class: "card-separator" }, null, -1)),
      t("div", g, [
        t("span", {
          class: "subline",
          style: p(u.value)
        }, r(e.subline), 5),
        e.price ? (a(), l("span", C, r(e.price), 1)) : f("", !0)
      ])
    ], 2));
  }
}), _ = /* @__PURE__ */ b(S, [["__scopeId", "data-v-19d8a3e7"]]);
export {
  _ as default
};
